module.exports = __webpack_public_path__ + "img/sub_page_communication35.71287576.png";